module.exports = __webpack_public_path__ + "img/CF_2U.1e6fa3a0.jpg";